// 保存当前菜单栏的路径
export const savePaths = (state, paths) => {
    state.paths = paths;
};


// WEBPACK FOOTER //
// ./src/store/mutations.js